import { isClientOptingReact } from 'owa-optin';
import { makePinRequest } from 'owa-mail-addins';

export default function checkAndUpdatePinnedAddins() {
    if (isClientOptingReact()) {
        makePinRequest();
    }
}
